/**
 * 这个文件是放样式的，为什么要这样放。
 * 1. 如果打包出来了less，宿主不处理的话就会报错，(宿主有时候为了性能less文件是没有过编译的)
 * 2. 为了更好地tree-shaking，less文件也可以省掉不用打包进去。 
 */

export var scFileIconContainerStyle = {
  position: 'relative',
  boxSizing: 'border-box',
  flex: 'none'
};
export var scFileIconStyle = {
  backgroundSize: 'cover',
  height: '100%',
  width: '100%'
};
export var scFileIconShortCutStyle = {
  position: 'absolute',
  left: '0',
  bottom: '0',
  width: '50%',
  height: '50%',
  backgroundSize: 'cover',
  // eslint-disable-next-line @tencent/tdoc-standalone/no-use-uri-like-literal
  backgroundImage: "url('https://docs.gtimg.com/docs-design-resources/document-management/tencent-docs/svg/icon_quick.svg')"
};
export var scFileIconPlayButtonStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  margin: 'auto',
  width: '50%',
  height: '50%',
  backgroundSize: 'cover',
  backgroundImage: "url('')" // TODO: 等待上传播放按钮三角形
};
//# sourceMappingURL=style.js.map